import React from 'react';
import { Link } from 'react-router-dom';

// Dipakai oleh route /notauthorized: user sudah login tapi tidak berhak
// membuka halaman yang dituju.
const Cover404 = () => {
  document.title = 'Access Denied | HYROC';
  return (
    <div className='hy-status-page'>
      <div className='hy-status-card'>
        <div className='hy-status-icon is-danger'>
          <i className='ri-lock-2-line' aria-hidden='true'></i>
        </div>
        <div className='hy-status-code'>Error 403</div>
        <h1 className='hy-status-title'>Access denied</h1>
        <p className='hy-status-text'>
          You don&apos;t have permission to view this page. If you think this is
          a mistake, please contact your administrator.
        </p>
        <Link to='/dashboard' className='btn btn-primary px-4'>
          <i className='ri-home-4-line me-2 align-middle'></i>Back to dashboard
        </Link>
      </div>
    </div>
  );
};

export default Cover404;
